import React, {FC, ReactNode} from 'react'

const Svg: FC<{children: ReactNode}> = ({children}) => (
    <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        {children}
    </svg>
)

export const IconAlignLeft: FC = () => (
    <Svg>
        <line x1='4' y1='6' x2='4' y2='18' />
        <rect x='8' y='8' width='12' height='2' />
        <rect x='8' y='14' width='8' height='2' />
    </Svg>
)

export const IconAlignCenterH: FC = () => (
    <Svg>
        <line x1='12' y1='6' x2='12' y2='18' />
        <rect x='6' y='8' width='12' height='2' />
        <rect x='8' y='14' width='8' height='2' />
    </Svg>
)

export const IconAlignRight: FC = () => (
    <Svg>
        <line x1='20' y1='6' x2='20' y2='18' />
        <rect x='4' y='8' width='12' height='2' />
        <rect x='8' y='14' width='8' height='2' />
    </Svg>
)

export const IconAlignTop: FC = () => (
    <Svg>
        <line x1='6' y1='4' x2='18' y2='4' />
        <rect x='8' y='8' width='2' height='12' />
        <rect x='14' y='8' width='2' height='8' />
    </Svg>
)

export const IconAlignCenterV: FC = () => (
    <Svg>
        <line x1='6' y1='12' x2='18' y2='12' />
        <rect x='8' y='6' width='2' height='12' />
        <rect x='14' y='8' width='2' height='8' />
    </Svg>
)

export const IconAlignBottom: FC = () => (
    <Svg>
        <line x1='6' y1='20' x2='18' y2='20' />
        <rect x='8' y='4' width='2' height='12' />
        <rect x='14' y='8' width='2' height='8' />
    </Svg>
)

export const IconDistributeH: FC = () => (
    <Svg>
        <rect x='3' y='8' width='4' height='8' rx='1' />
        <rect x='10' y='8' width='4' height='8' rx='1' />
        <rect x='17' y='8' width='4' height='8' rx='1' />
    </Svg>
)

export const IconDistributeV: FC = () => (
    <Svg>
        <rect x='8' y='3' width='8' height='4' rx='1' />
        <rect x='8' y='10' width='8' height='4' rx='1' />
        <rect x='8' y='17' width='8' height='4' rx='1' />
    </Svg>
)

export const IconSameWidth: FC = () => (
    <Svg>
        <rect x='4' y='5' width='16' height='5' rx='1' />
        <rect x='4' y='14' width='10' height='5' rx='1' />
        <line x1='14' y1='16.5' x2='20' y2='16.5' />
        <polyline points='16,14 14,16.5 16,19' />
        <polyline points='18,14 20,16.5 18,19' />
    </Svg>
)

export const IconSameHeight: FC = () => (
    <Svg>
        <rect x='5' y='4' width='6' height='16' rx='1' />
        <rect x='14' y='4' width='6' height='10' rx='1' />
        <line x1='17' y1='14' x2='17' y2='20' />
        <polyline points='15,16 17,14 19,16' />
        <polyline points='15,18 17,20 19,18' />
    </Svg>
)
